import type { TextTitledBodyData } from "@/types/storyboard";
import { titledBodyMarkdown } from "@/components/storyboard/text/utils/titledBodyMarkdown";

export type StructuredProblemSolvingContent = {
  title: string;
  body: string;
};

export type LegacyProblemSolvingContent = {
  body: string;
};

export type ResolvedProblemSolvingContent =
  | StructuredProblemSolvingContent
  | LegacyProblemSolvingContent;

// Structured payload — `{ title, body }`.
// Title comes from JSON. Markdown is rendered as-is (no heading promotion).
const resolveStructuredProblemSolving = (
  data: TextTitledBodyData
): StructuredProblemSolvingContent => ({
  title: data.title,
  body: titledBodyMarkdown(data),
});

// Legacy fallback — older courses send text: string
// Full markdown is the body. No ContentBlock title (headings stay in markdown).
const resolveLegacyProblemSolvingString = (
  text: string
): LegacyProblemSolvingContent => ({
  body: text,
});

// Entry point — TextProblemSolving branches here once on payload shape
export const resolveProblemSolvingContent = (
  data: TextTitledBodyData | string
): ResolvedProblemSolvingContent =>
  typeof data === "string"
    ? resolveLegacyProblemSolvingString(data)
    : resolveStructuredProblemSolving(data);
